import { type OrderItem } from '../../types'

export const getItemGroupLabel = (item: OrderItem): string => {
  let label = item.title
  label = label ?? item.uniqueName
  label = label ?? item.sid
  return label
}
